import React, { useState } from "react";
import { InfoIcon, Tooltip } from "./style";

interface IProps {
  message: string;
}

const TooltipComp: React.FC<IProps> = ({ message }: IProps) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
      className="tooltip-info-field-container"
    >
      <InfoIcon className="info-icon">?</InfoIcon>

      {showTooltip && (
        <Tooltip className="tooltip-info-field">
          <p>{message}</p>
        </Tooltip>
      )}
    </div>
  );
};

export default TooltipComp;
